import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=02b90b98&"
import script from "./Glossary.vue?vue&type=script&lang=ts&"
export * from "./Glossary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports